import controdata from './controdata/Theme';  

const themeLoader = {controdata};
let theme;
switch (process.env.REACT_APP_THEME) {
  case 'controdata':
    theme = themeLoader.controdata; 
    break;
  default:
    theme = themeLoader.controdata; 
}

export default theme;
